import { gql } from "@apollo/client";
import { createAction } from "@logicsoftware/redux-toolkit";
import { takeLatest } from "redux-saga/effects";
import { Query } from "~/common/graphql/__generated__/graphql";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { callApi } from "~/Redux/Sagas/effects/callApi";

type Payload = { id: number };
export const loadCanViewSpace = createAction<Payload>("SPACES/loadCanViewSpace");

export function* loadCanViewSpaceWatcher() {
    yield takeLatest(loadCanViewSpace, function* ({ payload: { id } }) {
        yield callApi(() => loadCanViewSpaceApi(id));
    });
}

export const loadCanViewSpaceApi = async (id: number): Promise<boolean> => {
    const { data } = await OAuthClient.graphql<Pick<Query, "byId">>(appUrls.spaces.graphql, {
        query: gql`
            query GetSpaceCanView($id: Int!) {
                byId(id: $id) {
                    spaceId
                }
            }
        `,
        variables: { id },
    });

    return !!data.byId?.spaceId;
};
